import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(portfolio)/project-details/[slug]/page.jsx");
